import { apiWrapper } from "@/services/api";
import store from "@/store";

export const createBookGroupWithVoucher = async (params) => {
  let response;
  try {
    response = await apiWrapper("POST", "voucher_code_book_groups", params);
    store.commit("ticketing/setbookGroup", response.data);
    store.commit("ticketing/setBook", response.data.books[0]);
    return response.data;
  } catch (err) {
    console.log('ERROR"" createBookGroupWithVoucher()');
    throw err;
  }
};
